import * as React from 'react';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import SidebarContext, {SidebarContextValue} from './SidebarContext';
import ToggleButton from './components/ToggleButton';
import Header from './components/Header';
import Menu from './components/Menu';
import {FavoriteCourse} from 'components/FavoriteCourse';
import AppStore from 'stores/AppStore';
import UserStore from 'stores/UserStore';

const Container = styled.aside<{
  isToggle?: boolean;
}>`
  z-index: 999;
  position: sticky;
  top: 0;

  flex-shrink: 0;
  width: ${({isToggle}) => !isToggle ? '96px' : '250px'};
  height: 100vh;
  
  display: flex;
  flex-direction: column;

  padding-top: ${({isToggle}) => !isToggle ? '130px' : '84px'};
;
  box-sizing: border-box;
  
  border-top-right-radius: 20px;
  background-color: ${({theme}) => `
    ${theme.variables.accentBackgroundColor};
  `};
`;

/**
 * This component renders the sidebar.
 * @return {React.ReactElement}
 * @constructor
 */
function Sidebar(): React.ReactElement {
  const isToggle = AppStore.isSidebarToggle;

  /**
   * Upgrade set toggle function.
   * @param {boolean} isToggle
   */
  function setToggle(isToggle: boolean): void {
    AppStore.isSidebarToggle = isToggle;
  }

  /**
   * Get the context value.
   * @return {SidebarContextValue}
   */
  function getContextValue(): SidebarContextValue {
    return {
      isToggle,
      setToggle,
    };
  }

  return (
    <SidebarContext.Provider value={getContextValue()}>
      <Container isToggle={isToggle}>
        <ToggleButton />
        <Header />
        {UserStore.isStudent() && (
          <FavoriteCourse
            isToggle={isToggle}
          />
        )}
        <Menu />
      </Container>
    </SidebarContext.Provider>
  );
}

export default observer(Sidebar);
